import { render } from "./riquadriVue.vue?vue&type=template&id=b9ef8890"
import script from "./riquadriVue.vue?vue&type=script&lang=js"
export * from "./riquadriVue.vue?vue&type=script&lang=js"

import "./riquadriVue.vue?vue&type=style&index=0&id=b9ef8890&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__